import KunLoading49 from './src/index'

KunLoading49.install = function (Vue) {
	Vue.component(KunLoading49.name, KunLoading49);
}

export default KunLoading49;
